<template>
  <div id="login" @scroll="handleScroll">
    <!-- 头部 标题 -->
    <div style="font-size: 18px" class="title f_w">
      {{contentData.title}}
    </div>
    <!-- 头部 时间 -->
    <div style="color: #999999;padding-bottom: 5px;border-bottom: 1px solid #f1f1f1;">
      <span>{{$commonJs.returnDate(contentData.lastModificationTime, 'YYMMDD1')}}</span>
    </div>
     <!-- 头部 阅读 -->
      <!--add by clh@20260615 隐藏文章列表和文章详情中的阅读数量-->
    <!-- <div style="margin: 5px 0 5px 0">
      <img class="read-icon" src="../../assets/icon_read.png" alt="">
      <span class="read-txt">{{likedData.readcount}}</span>
    </div> -->
    <!-- 正文 音频 -->
    <audio controls class="audioPlay" v-if="contentData.isAudio">
      <!-- <source :src="this.contentData.sourceUrl"> -->
      <source type="audio/wav" :src="baseInfo.baseUrl + '/api/Article/AudioFile/'+ contentData.id">
    </audio>
    <!-- 正文 -->
    <div style="padding-bottom: 0;" id="Arcitle" v-html="contentData.content" ref="Arcitle" ></div>

    <!-- 目录 -->
    <div style="width: 100%;height: 100px;min-height: 100px;border: 1px solid #999;box-sizing: border-box;background-color: #FAFAFA;padding: 10px 0;position: relative;top:-40px" v-if="catalogueList.topicName">
      <p style="height: 20px;text-indent: 10px;color: #999;" @click="showML"> {{catalogueList.topicName}} - 目录<i class="el-icon-s-unfold
e"></i></p>
      <div style="display: flex;align-items: center;justify-content: space-around;height: calc(100% - 25px);margin-top: 5px;">
        <div v-show="catalogueList.lastId&&catalogueList.nextId" style="width: 50%;height: 100% ;box-sizing: border-box;padding: 0 10px;" @click="goJumpLink($event,catalogueList.lastId)">
        <p>&lt; 上一篇</p>
        <p style="width: 100%;word-wrap: break-word;margin-top: 5px;padding-left: 10px;box-sizing: border-box;">{{ catalogueList.lastTitle }}</p>
      </div>
      <div v-show="catalogueList.lastId&&catalogueList.nextId" style="width: 50%;border-left: 1px solid #999;height: 100%;box-sizing: border-box;padding: 0 10px;" @click="goJumpLink($event,catalogueList.nextId)"> 
        <p style="text-align: right;">下一篇 ></p>
        <p style="width: 100%;word-wrap: break-word;margin-top: 5px;text-align: right;padding-right: 10px;box-sizing: border-box;">{{ catalogueList.nextTitle }}</p>
      </div>
      <p v-show="catalogueList.lastId&&!catalogueList.nextId" @click="goJumpLink($event,catalogueList.lastId)">&lt; 上一篇 - {{ catalogueList.lastTitle }}</p>
      <p v-show="!catalogueList.lastId&&catalogueList.nextId" @click="goJumpLink($event,catalogueList.nextId)">下一篇 - {{ catalogueList.nextTitle }} ></p>
      </div>
      
    </div>

    <!-- 底部 -->
    <!-- <div style="margin-top: 20px;margin-bottom: 20px">
      <span style="vertical-align: top" class="ds_inblok">阅读</span><span style="vertical-align: top" class="ds_inblok magleft_2"> {{likedData.readcount}}</span>
      <span style="margin-left: 5px;vertical-align: top;position:relative;top:-1px;" @click="postLike" :class="liked? 'colorYellow':''" class="ds_inblok v_m">
        <i style="color: #999;font-size: 16px!important;" v-if="!liked" class="icon iconfont iconxin"></i>
        <i style="font-size: 16px!important;" v-if="liked" class="icon iconfont iconxinfensi"></i>
      </span>

      <span style="vertical-align: top" :class="liked? '':''" class="ds_inblok magleft_2"> {{likedData.likecount}}</span>
      <span v-if="!faved" @click="postFav" class="ds_inblok" style="margin-left: 5px;vertical-align: top"><i v-if="!faved" style="color: #999;font-size: 16px!important;position:relative;top:-1px;margin-right: 2px" class="icon iconfont iconshoucang"></i>收藏</span>
      <span v-if="faved" @click="dispostFav" class="ds_inblok" style="margin-left: 5px;vertical-align: top"><i v-if="faved" style="font-size: 16px!important;position:relative;top:-1px;margin-right: 2px" class="icon colorYellow iconfont iconshoucang1"></i>已收藏</span>
    </div> -->
    <!-- 审核编号、声明 -->
    <!--<div v-if="contentData.auditNo || contentData.declared" style="margin-bottom: 100px;">-->
    <!--  <div style="margin-bottom: 10px;color:rgb(137,137,137);">-->
    <!--    <span>审核编号：</span>-->
    <!--    <span>{{contentData.auditNo}}</span>-->
    <!--  </div>-->
    <!--  <div style="margin-bottom: 10px;color:rgb(137,137,137);">-->
    <!--    <span>声明：</span>-->
    <!--    <span>{{contentData.declared}}</span>-->
    <!--  </div>-->
    <!--</div>-->
    <!-- 底部 新 -->
    <div class="bottom-icon-box">
      <!-- 点赞 -->
      <div :class="liked ? 'bottom-icons icons-checked' : 'bottom-icons'" @click="postLike">
        <img v-show="!liked" class="icons-img" src="../../assets/icon_like_red.png" alt="">
        <img v-show="liked" class="icons-img" src="../../assets/icon_like_white.png" alt="">
      </div>
      <!-- 收藏 -->
      <div :class="faved ? 'bottom-icons icons-checked' : 'bottom-icons'" @click="handleFavorite">
        <img v-show="!faved" class="icons-img" src="../../assets/icon_favorite_red.png" alt="">
        <img v-show="faved" class="icons-img" src="../../assets/icon_favorite_white.png" alt="">
      </div>

      <div v-if="contentData.researchId" :class="surd ? 'bottom-icons icons-checked' : 'bottom-icons'">
        <img @click="goSur" v-show="!surd" class="icons-img" src="../../assets/icon_sur_red.png" alt="">
        <img @click="$commonJs.showTips('您已提交')" v-show="surd" class="icons-img" src="../../assets/icon_dev_red.png" alt="">
      </div>
    </div>
    <div v-if="showSur">
      <div class="alertcover"></div>
      <div class="allalertModel">
        <div style="padding: 10px">
          <div style="letter-spacing: 6px">邀请您填写一份调研</div>
          <div style="letter-spacing: 6px;margin-top: 20px">{{ surModel.researchName }}</div>
          <div style="margin-top: 20px">
            <img width="60%" src="../../assets/surAlert.png" alt="">
          </div>
          <div style="margin-top: 20px">
            <div @click="goSur" style="border-radius: 100px;background: #f1f1f1;padding: 8px 26px;width:60%;display:inline-block;">点击参与</div>
          </div>
          <abbr @click="showSur = false" style="display: inline-block;margin-left:10px;border-radius: 100px;border: 1px solid #fff;position: relative;top: 50px; color:#fff;width: 22px;height: 22px;line-height: 20px;text-align: center;font-size: 20px">X</abbr>

        </div>
      </div>
    </div>
        <agreeBookDialog v-if="ABDialogShow" :ABDialogShow="ABDialogShow" :openId="openId" @ABDialogShowFn="ABDialogShowFn"></agreeBookDialog>


        <van-popup
      v-model="popupshow"
      closeable
      close-icon-position="top-left"
      position="bottom"
      :style="{ height: '70%' }"
      close-icon="down"
    >
    <div class="popupAll" style="height: 100%;overflow-y: hidden;">
      <div class="popupHead" style="background-color: #fff;height: 50px;color: #000;">
        <p style="text-align: center;font-size: 16px;line-height: 50px;">{{ cataloguetopname }}</p>
      </div>

      <div style="box-sizing: border-box;padding:10px 20px 10px 40px;height: calc(100% - 50px);overflow-y: auto;">
        <div v-for="(items,index) in catalogueALLlist" :key="index" style="width: 100%;word-wrap: break-word;box-sizing: border-box;padding: 20px 0;border-bottom: 1px solid  #CCCCCD;position: relative;" @click="goJumpLink($event,items.articleId)">
          <div v-show="items.isCurrent" style="width: 4px;height: 4px;border-radius: 50%;background-color:lawngreen;position: absolute;left: -20px;top:calc(50% - 5px);"></div>
          <span :style="items.isCurrent?'font-size: 14px;font-weight: 600;':''">{{ index+1 }}.{{ items.title }}</span>
          
        </div>

      </div>
    </div>
  
  </van-popup>

  </div>
</template>

<script>
import wx from 'weixin-js-sdk'
import merge from 'webpack-merge';
import agreeBookDialog from "./agreeBookDialog";
var RollingRatio = 0
let timeout
let timeout2
// window.onunload = function(){
//   if (vueC.startId) {
//     vueC.$axiox.get('/api/ArticlDoctor/readend/' + this.startId).then(p => {
//     })
//   }
// }

window.addEventListener('pagehide', () => {
  setTimeout(function () {}, 1000)
  if (startId) {
    console.log('位置1')
    let url = baseUrl + '/api/ArticlDoctor/readend/' + startId + '?RollingDepth=' + RollingRatio
    var xmlResquest = new XMLHttpRequest()
    xmlResquest.open('GET', url, false)
    xmlResquest.setRequestHeader('Content-type', 'application/json')
    xmlResquest.setRequestHeader('AppId', window.sessionStorage.getItem('AppId'))
    xmlResquest.setRequestHeader('Authorization', 'Bearer ' + window.sessionStorage.getItem('TaToken'))
    xmlResquest.send()
  }
})
window.onbeforeunload = function () {
  setTimeout(function () {}, 1000)
  if (startId) {
    console.log('位置2')
    let url = baseUrl + '/api/ArticlDoctor/readend/' + startId + '?RollingDepth=' + RollingRatio
    var xmlResquest = new XMLHttpRequest()
    xmlResquest.open('GET', url, false)
    xmlResquest.setRequestHeader('Content-type', 'application/json')
    xmlResquest.setRequestHeader('AppId', window.sessionStorage.getItem('AppId'))
    xmlResquest.setRequestHeader('Authorization', 'Bearer ' + window.sessionStorage.getItem('TaToken'))
    xmlResquest.send()
  }
}
window.unload = function () {
  setTimeout(function () {}, 1000)
  if (startId) {
    console.log('位置3')
    let url = baseUrl + '/api/ArticlDoctor/readend/' + startId + '?RollingDepth=' + RollingRatio
    var xmlResquest = new XMLHttpRequest()
    xmlResquest.open('GET', url, false)
    xmlResquest.setRequestHeader('Content-type', 'application/json')
    xmlResquest.setRequestHeader('AppId', window.sessionStorage.getItem('AppId'))
    xmlResquest.setRequestHeader('Authorization', 'Bearer ' + window.sessionStorage.getItem('TaToken'))
    xmlResquest.send()
  }
}
var isPageHide = false
window.addEventListener('pageshow', function () {
  if (isPageHide) {
    window.location.reload()
  }
})

window.addEventListener('pagehide', function () {
  isPageHide = true
})
// let vueC
let startId
let baseUrl = process.env.config.baseUrl
let seviceUrl = process.env.config.seviceUrl
export default {
  name: 'login',
  data () {
    return {
      // RID=xxxx&source=oce
      RID: this.$route.query.RID,
      source: '',
      parentId: this.$route.query.parentId,
      postData: {
        docName: '',
        department: '',
        Province: '',
        instName: '',
        City: ''
      },
      id: parseInt(this.$route.query.id),
      loginName: '',
      ABDialogShow:false,
      password: '',
      openId: '',
      appid: '',
      doctorId: '',
      departList: [],
      provList: [],
      liked: false,
      faved: false,
      showSur: false,
      surd: false,
      hospitalList: [],
      cityList: [],
      redirectUrl: this.$route.query.redirectUrl,
      contentData: {},
      likedData: {},
      returnurl: decodeURIComponent(this.$route.query.returnurl || ''),
      time: 0,
      startId: 0,
      player: new Audio(),
      surModel: {},
      baseInfo: {
        baseUrl: 'https://wechat-dev.takeda.com.cn',
        seviceUrl: 'https://wechatweb-dev.takeda.com.cn',
        myhouse: false
      },
      jumptovctag: this.$route.query.jumptovctag || '',
      NewerTag: this.$route.query.NewerTag || '',
      takedacode: this.$route.query.takedacode || '',
      catalogueList:null,
      cataloguetopname:'',
      catalogueALLlist:null,
      popupshow:false,
      isRefreshing: false, // 标志位
      MYscrollBottom:0
    }
  },
  components: { agreeBookDialog },
  beforeDestroy () {
    
    if (this.startId) {
      console.log('位置4')
      clearTimeout(timeout)
      clearTimeout(timeout2)
      this.$axiox.get('/api/ArticlDoctor/readend/' + this.startId + '?RollingDepth=' + RollingRatio).then(p => {
        // alert('beforeDestroy')
      })
    }

//     this.$router.push({
// query:merge(this.$route.query,{'jumptovctag':''})
// })

  },
  created () {
// 获取设备类型
const isIOS = /iphone|ipad|ipod/i.test(navigator.userAgent);
// 获取需要的 URL
const getSignUrl = () => {
  if (isIOS) {
    const myiosurl = localStorage.getItem('firstVisitUrl')
    if(myiosurl.indexOf('mobileContent')>-1){

      return location.href.split('#')[0];
    }else{
      window.location.reload()
      // return localStorage.getItem('firstVisitUrl'); // iOS 使用首次访问地址
    }
  }
  return location.href.split('#')[0]; // Android 使用当前页面地址
};

const url = getSignUrl()


    this.$axiox.get('/api/wechat/Getjssdksign?url=' + encodeURIComponent(url)).then(p => {
              wx.config({
                debug: false, // 开启调试模式,
                appId: p.appId, // 必填，企业号的唯一标识，此处填写企业号corpid
                timestamp: p.timestamp, // 必填，生成签名的时间戳
                nonceStr: p.nonceStr, // 必填，生成签名的随机串
                signature: p.signature, // 必填，签名，见附录1
                jsApiList: ['hideMenuItems', 'hideAllNonBaseMenuItem','showMenuItems','showAllNonBaseMenuItem','onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
              })
              wx.ready(function (msg) {
                var menuList = [
                  'menuItem:share:qq',
                  'menuItem:share:weiboApp',
                  'menuItem:favorite',
                  'menuItem:share:QZone',
                  'menuItem:copyUrl',
                  'menuItem:readMode',
                  'menuItem:originPage',
                  'menuItem:openWithQQBrowser',
                  'menuItem:openWithSafari',
                  'menuItem:share:email'
                ]
                wx.hideMenuItems({
                  menuList
                })
                wx.hideAllNonBaseMenuItem()
              })
              // 关闭分享按钮
              // try {
              //   this.$nextTick(() => {
              //     wx.hideOptionMenu()
              //     function onBridgeReady () {
              //       WeixinJSBridge.call('hideOptionMenu')
              //     }
              //     if (typeof WeixinJSBridge == "undefined") {
              //       if (document.addEventListener){
              //           document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false)
              //       } else if (document.attachEvent) {
              //           document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
              //           document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
              //       }
              //     } else {
              //       onBridgeReady()
              //     }
              //   })
              // } catch (err) {
              //   console.log(err, 'err')
              // }
            })


    this.getCatalogue()


    
    if(this.$route.query.AttendType==='YMT')
    {
      this.$route.query.source = 'YMT'
    }
    this.source = this.$route.query.source
    
    if (timeout) {
      clearTimeout(timeout)
      clearTimeout(timeout2)
    }
    // 文件地址域名
    this.baseInfo.baseUrl = process.env.config.baseUrl
    this.baseInfo.seviceUrl = process.env.config.seviceUrl
   

    
 
     //如果参数中含有新用户标记，则清理缓存 (当前未考虑员工，仅考虑了医生)
     if(this.NewerTag.indexOf('Hcp')>-1){
      window.sessionStorage.removeItem("LsData");
                // 注册成功删除暂存的用户信息
      window.localStorage.removeItem("registerUserInfo");
      window.localStorage.removeItem("registerNonHCPInfo");
                // 删除员工标识
      window.localStorage.removeItem("isEmployee");
    }
    else if(this.NewerTag.indexOf('Emp')>-1)
    {
      window.localStorage.setItem('isEmployee', true);

    }
    else if(this.NewerTag.indexOf('NoHcp')>-1)
    {
      window.localStorage.removeItem("registerNonHCPInfo");
      window.localStorage.removeItem("registerUserInfo");
      this.$commonJs.mobileDoubleComfirm({
      buttonType: "0",
      type: "warning",
      title: "提示",
      content:
        "该平台仅供医疗卫生专业人士（HCP）使用，您已注册非HCP，暂无权限！",
      successFun: () => {
      },
      errorFun: (err) => {},
      });
      return 
    }

    console.log('TaToken', localStorage.TaToken)
    console.log('takedacode', this.takedacode)
    if (!localStorage.TaToken && !this.takedacode) {
      // process.env.config.baseUrl
      // window.location.host
      //进入文章详情登录前埋点
      this.actionBurialPoint(2)
      window.localStorage.setItem('isToTextLogin',true)
      setTimeout(()=>{
        let url = process.env.config.baseUrl + '/api/wechat/oauth2/authorize?redirect_uri=' + encodeURIComponent('https://' + window.location.host 
        + '/mobileContent?id=' + this.id 
        + '&returnurl=' + (this.returnurl || '') 
        + `${this.RID ? '&RID=' + encodeURIComponent(this.RID) : ''}` 
        + `${this.source ?  '&source=' + this.source : ''}` 
        + `${this.parentId ?  '&parentId=' + encodeURIComponent(this.parentId) : ''}`)
        window.location.href = url
      },2000)
      return
    } else {
      if (this.takedacode && !localStorage.TaToken) {
       
        this.$axiox.get('/Login/GetTokenByCode?code=' + this.takedacode).then(msg => {
          // 获取当前 URL
          const url = new URL(window.location.href);
          // 获取 URLSearchParams 对象
          const params = url.searchParams;
          // 删除指定的查询参数
          params.delete('takedacode');
          // 更新浏览器地址
          window.history.replaceState({}, '', url);

          
          localStorage.TaToken = msg.token
          localStorage.appId = msg.appId
          localStorage.openId = msg.openId
          this.openId = msg.openId
          this.appid = msg.appId
          
          console.log('id', this.id)
          if (this.id) {
            this.getDetail()
            this.getLiked()
          }
          console.log('openId', this.openId)
          if (this.openId) {
            // this.startRead()
            this.startReadNew()
            // 获取点赞状态
            this.isLikeHandler()
            // 获取收藏状态
            this.isFavHandler()
          }
        })
      } else {
         
        this.openId = localStorage.openId
        this.appid = localStorage.appId

        this.$axiox
          .get("/api/wechat/getIsLogin?openid=" + this.openId).then(res=>{
            if(res){

              let data = {
          openId: this.openId,
          returnurl: encodeURIComponent(window.location.href),
          docCode: ''
        }
        let title = ''
        if (
          process.env.config.seviceUrl.indexOf('wechatweb.takeda.com.cn') > -1
        ) {
          title = '吾医空间'
        } else {
          title = '吾医空间测试号'
        }
        this.$axiox.postNoRes(process.env.config.baseUrl + '/api/wechat/getdoctorstatus', data).then(p => {
          console.log('p.data', p.data)
          if (p.data.status === 2) {
            let data2 = {
              openId: this.openId,
              openid: this.openId,
              returnurl: encodeURIComponent(window.location.href)
            }
            this.$axiox.postNoRes(process.env.config.baseUrl + '/api/wechat/getEmployeeInfo?openid=' + this.openId, data2).then(p2 => {
              if (!p2.data) {
                if(this.$route.query.source == 'YMT')
                {
                  if(this.NewerTag.indexOf('NoHcp')>-1){

this.$commonJs.mobileDoubleComfirm({
buttonType: "0",
type: "warning",
title: "提示",
content:
  "该平台仅供医疗卫生专业人士（HCP）使用，您已注册非HCP，暂无权限！",
successFun: () => {
},
errorFun: (err) => {},
});
return 
}
                  //window.location.href = ('//' + window.location.host + '/register?ArticleFromYMT=true&returnurl=' + encodeURIComponent(window.location.href))
                  //this.$route.query.source = 'YMT'

                }else{
                  if(this.NewerTag.indexOf('NoHcp')>-1){

this.$commonJs.mobileDoubleComfirm({
buttonType: "0",
type: "warning",
title: "提示",
content:
  "该平台仅供医疗卫生专业人士（HCP）使用，您已注册非HCP，暂无权限！",
successFun: () => {
},
errorFun: (err) => {},
});
return 
}
                  //window.location.href = ('//' + window.location.host + '/register?returnurl=' + encodeURIComponent(window.location.href))

                }
              } else {
                console.log('id', this.id)
                if (this.id) {
                  this.getDetail()
                  this.getLiked()
                }
                console.log('openId', this.openId)
                if (this.openId) {
                  // this.startRead()
                  this.startReadNew()
                  // 获取点赞状态
                  this.isLikeHandler()
                  // 获取收藏状态
                  this.isFavHandler()
                }
              }
            })
          } else {
            console.log('id', this.id)
            if (this.id) {
              this.getDetail()
              this.getLiked()
            }
            console.log('openId', this.openId)
            if (this.openId) {
              // this.startRead()
              this.startReadNew()
              // 获取点赞状态
              this.isLikeHandler()
              // 获取收藏状态
              this.isFavHandler()
            }
          }
        })

            }else{

              let url = process.env.config.baseUrl + '/api/wechat/oauth2/authorize?redirect_uri=' + encodeURIComponent('https://' + window.location.host 
        + '/mobileContent?id=' + this.id 
        + '&returnurl=' + (this.returnurl || '') 
        + `${this.RID ? '&RID=' + encodeURIComponent(this.RID) : ''}` 
        + `${this.source ?  '&source=' + this.source : ''}` 
        + `${this.parentId ?  '&parentId=' + encodeURIComponent(this.parentId) : ''}`)
        window.location.href = url

            }
          })
        
      }

      if(window.localStorage.getItem('isToTextLogin')){
        window.localStorage.setItem('isToTextLogin','')
        // 文章详情登陆后埋点
        this.actionBurialPoint(3)
      }
 
    }

      setTimeout(() => {
        this.getSignDetail()
      }, 1000);

  },
  mounted () {

    if (process.env.config.seviceUrl.indexOf('wechatweb.takeda.com.cn') > -1) {
      document.title = '吾医空间'
    } else {
      document.title = '吾医空间测试号'
    }

    
    // setTimeout( () => {
    //   let that = this
    //   let shareUrl = seviceUrl + '/mobileContent?id=' + that.id
    //   if (that.$route.query.source) {
    //     shareUrl += `&source=${that.$route.query.source}`
    //     if (that.$route.query.RID) {
    //       shareUrl += `&RID=${that.$route.query.RID}&parentId=${that.openId}`
    //     } else {
    //       shareUrl += `&RID=${that.openId}&parentId=${that.openId}`
    //     }
    //   } else {
    //     shareUrl += `&source=WY&RID=${that.openId}&parentId=${that.openId}`
    //   }
    //   console.log(shareUrl)
    // }, 3000 )
  },
  beforeRouteLeave(to, from, next) {
    clearTimeout(timeout)
    clearTimeout(timeout2)
    next();
  },
  methods: {
    handleScroll() {
       const loginDiv = document.getElementById('login');
       const Arcitle = document.getElementById('Arcitle');
       // 获取当前可视区域高度
       const viewportHeight = window.innerHeight;
        // 获取当前滚动距离
        const scrollDistance = loginDiv.scrollTop + viewportHeight;
        // 获取文章高度
       const ArcitleHeight = Arcitle.offsetHeight;
      //计算阅读比例

      // 计算滚动条距离底部的高度
        const scrollBottom = loginDiv.scrollHeight - loginDiv.clientHeight - loginDiv.scrollTop;
        const isMytext = this.MYscrollBottom - scrollBottom
        const oldheight = (isMytext+200) / this.MYscrollBottom
        let MyRollingRatio = Math.round(oldheight * 10000) / 100;
        MyRollingRatio =  Math.trunc(MyRollingRatio)
      if(MyRollingRatio>RollingRatio){
        RollingRatio = MyRollingRatio
      }
      if(RollingRatio>100){
        RollingRatio=100
      }
      console.log('已阅读',RollingRatio)
    },
    actionBurialPoint(actionType){
      let data = {
            openid: this.openId || window.localStorage.getItem('openId'),
            actionType,
            url:window.location.href
          }
          this.$axiox.post('/api/Logs/logstart', data).then( p => {
            console.log('行为埋点')
          } )
    },
    getCatalogue(){
      this.$axiox.get('/api/minisite/topic?articleId=' + this.id).then(p => {
        console.log('pppppp',p)
        this.catalogueList = p
      })

    },
    showML(){
      this.$axiox.get('/api/minisite/topic/list?articleId=' + this.id).then(p => {
        console.log('catalogueALLlist',p)
        this.catalogueALLlist = p
        p.forEach(res=>{
          if(res.isCurrent){
            this.cataloguetopname = res.topicName
          }
        })
        this.popupshow = true
      })
    },
    goJumpLink(e,item){
      localStorage.setItem('firstVisitUrl', location.href.split('#')[0]);
      e.stopPropagation()
      let queries = JSON.parse(JSON.stringify(this.$route.query))
      queries.id = item
      queries.source = 'WY'
      queries.jumptovctag=this.jumptovctag
      let url = this.$commonJs.returnQuery('//' + window.location.host + '/mobileContent', queries)
      window.location.href = url;
    },

    getSignDetail() {
      let data = {
        openid: this.openId,
        docCode: "",
      };
      this.$axiox.postNoRes("/api/hcp/getHcpSignDetail", data).then((p) => {
        if (p.data == "True") {
          //name: "agreeBook",
            this.ABDialogShow = true;
        } else if (p.data == "False") {
        } //无需重新签署
        else {
        } //返回值错误
      });
    },
    ABDialogShowFn() {
      this.ABDialogShow =false;
    },
    getSurDetail (id) {
      this.$axiox.get('/api/Research/detail/' + id).then(p => {
        this.surModel = p
      })
    },
    goSur () {
      window.location.href = '//' + window.location.host + '/mobileSurvey?id=' + this.contentData.researchId + '&type=1&articleId=' + this.contentData.id
    },
    checkSur () {
      this.$axiox.get('/api/Research/records/isSubmited?openid=' + this.openId + '&researchId=' + this.contentData.researchId + '&type=' + 1 + '&articleId=' + (this.contentData.id || 0) + '&meetingemscode=').then(p => {
        if (p === 'True') {
          this.surd = true
        } else {
          this.showSur = true
        }
      })
    },
    isLikeHandler () {
      let data = {
        articleid: this.id,
        openid: this.openId
      }
      let url2 = this.$commonJs.returnQuery('/api/ArticlDoctor/islike', data)
      this.$axiox.get(url2).then(p => {
        console.log(p, 'islike')
        this.liked = (p === 'True')
      })
    },
    isFavHandler () {
      let data = {
        articleid: this.id,
        openid: this.openId
      }
      let url3 = this.$commonJs.returnQuery('/api/ArticlDoctor/isfav', data)
      this.$axiox.get(url3).then(p => {
        console.log(p, 'isfav')
        this.faved = (p === 'True')
      })
    },
    startReadNew () {
      console.log('startReadNew--source', this.source)
      let data = {
        articleid: this.id,
        openid: this.openId,
        source:  this.source || '',
        urL_VALUE: this.RID ? decodeURIComponent(this.RID) : '',
        parentId: this.parentId ? decodeURIComponent(this.parentId) : ''
      }
      // let url = this.$commonJs.returnQuery('/api/ArticlDoctor/readstart', data)
      this.$axiox.post('/api/ArticlDoctor/readstart', data).then(p => {
        console.log('位置5')
        console.log(p, 'startReadNew')
        this.startId = p
        const loginDiv = document.getElementById('login');
            const Arcitle = document.getElementById('Arcitle');
            // 获取当前可视区域高度
            const viewportHeight = window.innerHeight;
              // 获取文章高度
            const ArcitleHeight = Arcitle.offsetHeight;
            if(ArcitleHeight<=viewportHeight){
              this.MYscrollBottom = viewportHeight
              console.log('总内容未超过一页')
              RollingRatio = 100
            }else{
              this.MYscrollBottom = loginDiv.scrollHeight - loginDiv.clientHeight - loginDiv.scrollTop + viewportHeight;

              // 计算滚动条距离底部的高度
              const scrollBottom = this.MYscrollBottom - viewportHeight
              const isMytext = this.MYscrollBottom - scrollBottom
              const oldheight = (isMytext+200) / this.MYscrollBottom
              let MyRollingRatio = Math.round(oldheight * 10000) / 100
              MyRollingRatio = Math.trunc(MyRollingRatio)
              RollingRatio = MyRollingRatio
              if(RollingRatio>100){
                RollingRatio=100
              }
              console.log('长文章初始已阅读',RollingRatio)
            }
        this.endRead()
      })
    },
    endRead () {
      // clearTimeout(timeout)
      //   // let randomTime = (Math.floor(Math.random() * 15) + 15) * 1000
      //   let randomTime = 5000
      //   console.log(randomTime)
      //   this.$axiox.get('/api/ArticlDoctor/readend/' + this.startId, true).then(p => {
      //     timeout = setTimeout(_ => {
      //       this.endRead()
      //     }, randomTime)
      //   })


      // 原代码
        
      clearTimeout(timeout)
      clearTimeout(timeout2)
      timeout = setTimeout(p => {
          // let randomTime = (Math.floor(Math.random() * 15) + 15) * 1000
          let randomTime = 2000

          console.log(randomTime)
          this.$axiox.get('/api/ArticlDoctor/readend/' + this.startId + '?RollingDepth=' + RollingRatio, true).then(p => {
            console.log('循环调用')
            timeout2 = setTimeout(_ => {
              this.endRead()
            }, randomTime)
          })

      }, 1500)
    },
    startRead () {
      // 5s代码
      // clearTimeout(timeout)
      // // timeout = setTimeout(p => {
      //   // let randomTime = (Math.floor(Math.random() * 15) + 15) * 1000
      //   let randomTime = 5000
      //   console.log(randomTime)
      //   let data = {
      //     doctorid: this.openId,
      //     articleid: this.id,
      //     openid: this.openId,
      //     SOURCE: this.source || '',
      //     URL_VALUE: this.RID || '',
      //     parentId: this.parentId || ''
      //   }
      //   let url = this.$commonJs.returnQuery('/api/ArticlDoctor/readstart', data)
      //   this.$axiox.get(url, true).then(p => {
      //     this.startId = parseInt(p)
      //     startId = parseInt(p)
      //     timeout = setTimeout(p => {
      //       this.$axiox.get('/api/ArticlDoctor/readend/' + this.startId, true).then(p => {
      //         this.startRead()
      //       })
      //     }, randomTime)
      //   })
      // // }, 1000)


      // 原代码

      clearTimeout(timeout)
      clearTimeout(timeout2)
      timeout = setTimeout(p => {
        // let randomTime = (Math.floor(Math.random() * 15) + 15) * 1000
        let randomTime = 2000
        console.log(randomTime)
        let data = {
          doctorid: this.openId,
          articleid: this.id,
          openid: this.openId
        }
        console.log('位置7')
        let url = this.$commonJs.returnQuery('/api/ArticlDoctor/readstart', data)
        this.$axiox.get(url, true).then(p => {
          this.startId = parseInt(p)
          startId = parseInt(p)

          const loginDiv = document.getElementById('login');
            const Arcitle = document.getElementById('Arcitle');
            // 获取当前可视区域高度
            const viewportHeight = window.innerHeight;
              // 获取文章高度
            const ArcitleHeight = Arcitle.offsetHeight;
            if(ArcitleHeight<=viewportHeight){
              this.MYscrollBottom = viewportHeight
              console.log('总内容未超过一页')
              RollingRatio = 100
            }else{
              this.MYscrollBottom = loginDiv.scrollHeight - loginDiv.clientHeight - loginDiv.scrollTop + viewportHeight;

              // 计算滚动条距离底部的高度
              const scrollBottom = this.MYscrollBottom - viewportHeight
              const isMytext = this.MYscrollBottom - scrollBottom
              const oldheight = (isMytext+200) / this.MYscrollBottom
              let MyRollingRatio = Math.round(oldheight * 10000) / 100
              MyRollingRatio = Math.trunc(MyRollingRatio)
              RollingRatio = MyRollingRatio
              if(RollingRatio>100){
                RollingRatio=100
              }
              console.log('长文章初始已阅读',RollingRatio)
            }


          setTimeout(p => {
            this.$axiox.get('/api/ArticlDoctor/readend/' + this.startId + '?RollingDepth=' + RollingRatio, true).then(p => {
              this.startRead()
            })
          }, randomTime)
        })
      }, 1000)
    },
    getLiked () {
      this.$axiox.get('/api/ArticlDoctor/doctors/summary/' + this.id).then(p => {
        this.likedData = p
      })
    },
    // 处理点赞
    postLike () {
      //转发 Forward=1, 收藏 Fav=2, 取消收藏 UnFav=3, 点赞 Like=4
      let params = {
        actionType: 4,
        openId: this.openId,
        transactionId: this.startId,
        articleId: this.id,
        source: this.source || '',
        urL_VALUE: this.RID ? decodeURIComponent(this.RID) : '',
      }
      this.$axiox.post(`/api/ArticlDoctor/reportUserAction`, params).then(res => {
        // 获取点赞状态
        this.isLikeHandler()
      })
    },
    // async getEncryptedMsg(text){
    //   return await this.$axiox.asyncGetData(`/api/default/EncryptAES?text=${text}`)
    // },
     getDetail () {
      let that = this
      let url = '/api/Article/' + this.id
      this.$axiox.get(url).then( async (p)=> {
        if (!p || p.isinactive !== null){
          this.$commonJs.alertTips({
            type: 'error',
            title: '错误',
            content: '该文章已下架, 即将回到文章列表',
            stayTime: 2
          })
          setTimeout( () => {
            this.$router.push({
              path: '/articalCollections'
            })
          }, 1500 )

        } else {
          p.content = p.content.replace(/&lt;iframe/g, '<iframe').replace(/&gt;&lt;\/iframe&gt;/g, '></iframe>').replace(/&lt;source/g, '<source').replace(/\/&gt;/g, '/>')
          this.contentData = p
          
          setTimeout(()=>{
            const loginDiv = document.getElementById('login');
            const Arcitle = document.getElementById('Arcitle');
            // 获取当前可视区域高度
            const viewportHeight = window.innerHeight;
              // 获取文章高度
            const ArcitleHeight = Arcitle.offsetHeight;
            if(ArcitleHeight<=viewportHeight){
              this.MYscrollBottom = viewportHeight
              console.log('总内容未超过一页')
              RollingRatio = 100
              this.$axiox.get('/api/ArticlDoctor/readend/' + this.startId + '?RollingDepth=' + RollingRatio, true).then(p => {})
            }else{
              this.MYscrollBottom = loginDiv.scrollHeight - loginDiv.clientHeight - loginDiv.scrollTop + viewportHeight;

              // 计算滚动条距离底部的高度
              const scrollBottom = this.MYscrollBottom - viewportHeight
              const isMytext = this.MYscrollBottom - scrollBottom
              const oldheight = (isMytext+200) / this.MYscrollBottom
              let MyRollingRatio = Math.round(oldheight * 10000) / 100
              MyRollingRatio = Math.trunc(MyRollingRatio)
              RollingRatio = MyRollingRatio
              if(RollingRatio>100){
                RollingRatio=100
              }
              console.log('长文章初始已阅读',RollingRatio)
              this.$axiox.get('/api/ArticlDoctor/readend/' + this.startId + '?RollingDepth=' + RollingRatio, true).then(p => {})
            }
          },1500)

          this.$nextTick(p => {
            let tencentTweets = document.getElementById('tencentTweets')
            if (tencentTweets) {
              let spanList = tencentTweets.querySelectorAll('span')
              console.log(spanList)
              for (let i = 0; i < spanList.length; i++) {
                if ((i === 1 || i === 3) && spanList[i].innerHTML === 'null') {
                  spanList[i].innerHTML = ''
                }
              }
            }

          })
          if (this.contentData.researchId) {
            this.checkSur()
            this.getSurDetail(this.contentData.researchId)
          }
          
          if (!this.contentData.iscanfoward) {
            this.$axiox.get('/api/wechat/Getjssdksign?url=' + encodeURIComponent(window.location.href)).then(p => {
              wx.config({
                debug: false, // 开启调试模式,
                appId: p.appId, // 必填，企业号的唯一标识，此处填写企业号corpid
                timestamp: p.timestamp, // 必填，生成签名的时间戳
                nonceStr: p.nonceStr, // 必填，生成签名的随机串
                signature: p.signature, // 必填，签名，见附录1  
                jsApiList: ['hideMenuItems', 'hideAllNonBaseMenuItem'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
              })
              wx.ready(function (msg) {
                var menuList = [
                  'menuItem:share:qq',
                  'menuItem:share:weiboApp',
                  'menuItem:favorite',
                  'menuItem:share:QZone',
                  'menuItem:copyUrl',
                  'menuItem:readMode',
                  'menuItem:originPage',
                  'menuItem:openWithQQBrowser',
                  'menuItem:openWithSafari',
                  'menuItem:share:email'
                ]
                wx.hideMenuItems({
                  menuList
                })
                wx.hideAllNonBaseMenuItem()
              })
              // 关闭分享按钮
              try {
                this.$nextTick(() => {
                  wx.hideOptionMenu()
                  function onBridgeReady () {
                    WeixinJSBridge.call('hideOptionMenu')
                  }
                  if (typeof WeixinJSBridge == "undefined") {
                    if (document.addEventListener){
                        document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false)
                    } else if (document.attachEvent) {
                        document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
                        document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
                    }
                  } else {
                    onBridgeReady()
                  }
                })
              } catch (err) {
                console.log(err, 'err')
              }
            })
          } else {

// 获取设备类型
// const isIOS = /iphone|ipad|ipod/i.test(navigator.userAgent);
// 获取需要的 URL
// const getSignUrl = () => {
//   if (isIOS) {
//     const myiosurl = localStorage.getItem('firstVisitUrl')
//     if(myiosurl.indexOf('mobileContent')>-1){
//       return location.href.split('#')[0];
//     }else{
//       window.location.reload()
//       // return localStorage.getItem('firstVisitUrl'); // iOS 使用首次访问地址
//     }
//   }
//   return location.href.split('#')[0]; // Android 使用当前页面地址
// };
            // let url = getSignUrl()
            // this.$axiox.get('/api/wechat/Getjssdksign?url=' + encodeURIComponent(url)).then(async p => {
              
              // wx.config({
              //   debug: false, // 开启调试模式,
              //   appId: p.appId, // 必填，企业号的唯一标识，此处填写企业号corpid
              //   timestamp: p.timestamp, // 必填，生成签名的时间戳
              //   nonceStr: p.nonceStr, // 必填，生成签名的随机串
              //   signature: p.signature, // 必填，签名，见附录1
              //   jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
              // })

              let shareUrl = seviceUrl + '/mobileContent?id=' + that.id
              let tempStr = encodeURIComponent(await that.$axiox.asyncGetData(`/api/default/EncryptAESToHexString?text=${that.openId}`))
              if (that.$route.query.source) {
                shareUrl += `&source=${that.$route.query.source}`
                if (that.$route.query.RID) {
                  shareUrl += `&RID=${encodeURIComponent(decodeURIComponent(that.$route.query.RID))}&parentId=${tempStr}`
                } else {
                  shareUrl += `&RID=${tempStr}&parentId=${tempStr}`
                }
              } else {
                shareUrl += `&source=WY&RID=${tempStr}&parentId=${tempStr}`
              }
              
              // wx.ready(function (msg) {

                var menuList = [
                  'menuItem:share:qq',
                  'menuItem:share:weiboApp',
                  'menuItem:favorite',
                  'menuItem:share:QZone',
                  'menuItem:copyUrl',
                  'menuItem:readMode',
                  'menuItem:originPage',
                  'menuItem:openWithQQBrowser',
                  'menuItem:openWithSafari',
                  'menuItem:share:email'
                ]
                wx.showMenuItems({
                  menuList
                })
                wx.showAllNonBaseMenuItem()
              
                console.log('分享')
                wx.onMenuShareTimeline({
                  title: that.contentData.title,
                  link: shareUrl,
                  desc: that.contentData.summary,
                  imgUrl: that.baseInfo.baseUrl + '/api/Article/file/' + that.contentData.fileID,
                  success: function () {
                    // 用户确认分享后执行的回调函数
                    that.handleForward()
                  },
                  cancel: function () {
                    // 用户取消分享后执行的回调函数
                  }
                })
                wx.onMenuShareAppMessage({
                  title: that.contentData.title,
                  link: shareUrl,
                  desc: that.contentData.summary,
                  imgUrl: that.baseInfo.baseUrl + '/api/Article/file/' + that.contentData.fileID,
                  success: function (msg) {
                    // 用户确认分享后执行的回调函数
                    that.handleForward()
                  },
                  cancel: function (msg) {
                    // 用户取消分享后执行的回调函数
                  }
                })
                wx.onMenuShareQQ({
                  title: that.contentData.title,
                  link: shareUrl,
                  desc: that.contentData.summary,
                  imgUrl: that.baseInfo.baseUrl + '/api/Article/file/' + that.contentData.fileID,
                  success: function () {
                    // 用户确认分享后执行的回调函数
                    that.handleForward()
                  },
                  cancel: function () {
                    // 用户取消分享后执行的回调函数
                  }
                })
                wx.onMenuShareWeibo({
                  title: that.contentData.title,
                  link: shareUrl,
                  desc: that.contentData.summary,
                  imgUrl: that.baseInfo.baseUrl + '/api/Article/file/' + that.contentData.fileID,
                  success: function () {
                    // 用户确认分享后执行的回调函数
                    that.handleForward()
                  },
                  cancel: function () {
                    // 用户取消分享后执行的回调函数
                  }
                })
                wx.onMenuShareQZone({
                  title: that.contentData.title,
                  link: shareUrl,
                  desc: that.contentData.summary,
                  imgUrl: that.baseInfo.baseUrl + '/api/Article/file/' + that.contentData.fileID,
                  success: function () {
                    // 用户确认分享后执行的回调函数
                    that.handleForward()
                  },
                  cancel: function () {
                    // 用户取消分享后执行的回调函数
                  }
                })

                
              // })
            // })


          }
        }
       
      })
    },
    // 处理收藏
    handleFavorite () {
      //转发 Forward=1, 收藏 Fav=2, 取消收藏 UnFav=3, 点赞 Like=4
      let params = {
        actionType: this.faved ? 3 : 2,
        openId: this.openId,
        transactionId: this.startId,
        articleId: this.id,
        source: this.source || '', 
        urL_VALUE: this.RID ? decodeURIComponent(this.RID) : '',
      }
      this.$axiox.post(`/api/ArticlDoctor/reportUserAction`, params).then(res => {
        // 获取收藏状态
        this.isFavHandler()
      })
    },
    // 处理转发
    handleForward () {
      //转发 Forward=1, 收藏 Fav=2, 取消收藏 UnFav=3, 点赞 Like=4
      let params = {
        actionType: 1,
        openId: this.openId,
        transactionId: this.startId,
        articleId: this.id,
        source: this.source || '',
        urL_VALUE: this.RID ? decodeURIComponent(this.RID) : '',
      }
      this.$axiox.post(`/api/ArticlDoctor/reportUserAction`, params).then(res => {
        console.log(res, '转发')
      })
    }
  }
}
</script>

<style scoped>
.sl_color {
  color: #408deb;
}
#login {
  justify-content: center;
  align-items: center;
  height: 100vh;
  overflow-y: auto;
  padding: 0 5%;
  background-color: #fff;
}
.title {
  margin-top: 5px;
  font-size: 14px;
}

.audioPlay {
  width: 100%;
  margin: 10px 0;
}
.read-icon {
  display: inline-block;
  width: 16px;
  height: 11px;
}
.read-txt {
  margin-left: 5px;
  color: rgba(16, 16, 16, 100);
  font-size: 12px;
  text-align: left;
  font-family: PingFangSC-regular;
}
.bottom-icon-box {
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  text-align: center;
  padding-bottom: 15px;
}
.bottom-icons {
  display: inline-block;
  width: 61px;
  height: 61px;
  margin: 0 20px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 100);
  box-shadow: 0px 2px 6px 0px rgba(0,0,0,0.19);
  position: relative;
}
.icons-img {
  width: 30px;
  height: 30px;
  display: block;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%)
}
.icons-checked {
  background-color: #F00E00;
}
</style>



// WEBPACK FOOTER //
// src/components/login/mobileContent.vue